"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mongoose_1 = require("mongoose");
const enum_1 = require("./enum");
const memberSchema = new mongoose_1.Schema({
    user: {
        type: mongoose_1.Schema.Types.ObjectId,
        ref: "User",
    },
    email: String,
    team: {
        type: mongoose_1.Schema.Types.ObjectId,
        ref: "Team",
    },
    role: {
        type: String,
        enum: Object.values(enum_1.ROLES),
        default: enum_1.ROLES.MEMBER,
    },
    accepted: {
        type: Boolean,
        default: false,
    },
    invitedBy: {
        type: mongoose_1.Schema.Types.ObjectId,
        ref: "User",
    },
    featureOnboarded: {
        type: Boolean,
        default: false,
    },
    permissions: [{ type: mongoose_1.Schema.Types.ObjectId, ref: "MemberPermission" }],
}, {
    timestamps: {
        createdAt: "created_at",
        updatedAt: "updated_at",
    },
});
exports.default = (0, mongoose_1.model)("Member", memberSchema);
